// extracted by mini-css-extract-plugin
module.exports = {"icon":"src-components-UI-Icons-styles-style-module__icon--2bYge","svg-inline--fa":"src-components-UI-Icons-styles-style-module__svg-inline--fa--G1YDU"};